@if (uiSref) {
	<a class="type-bold" [ngClass]="cssClass" [uiSref]="uiSref" [uiParams]="uiSrefParams" [uiOptions]="uiOptions">
		<ng-container *ngTemplateOutlet="linkContent"></ng-container>
	</a>
}

@if (href){
	<a class="type-bold" [target]="target || '_self'" [ngClass]="cssClass" [href]="href">
		<ng-container *ngTemplateOutlet="linkContent"></ng-container>
	</a>
}

@if (plainText) {
	<span class="margin-5" [innerHTML]="plainText | highlight : highlightText : highlightClass">
	</span>
}

@if (callbackFn) {
	<button type="button" class="btn btn-transparent padding-0" [ngClass]="cssClass" (click)="callbackFn(linkText)">
		<ng-container *ngTemplateOutlet="linkContent"></ng-container>
	</button>
}

<ng-template #linkContent>
	@if (iconClass) {
		<span [ngClass]="iconClass"></span>
	}
	<span [innerHTML]="linkText | highlight : highlightText : highlightClass"></span>
</ng-template>
